import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";

export class ContactsModel {
    address = new EditableFieldModel('address', FieldType.text, 'Moscow 1');
    supportEmail = new EditableFieldModel('email', FieldType.email, 'support@email.com');
    phoneNumber = new EditableFieldModel('phone', FieldType.phone, '+333333333333333');

    fieldsMap = [this.address, this.supportEmail, this.phoneNumber];

    constructor(data?: {address?: any, supportEmail?: any, phoneNumber?: any}) {
        if(data?.address){
            this.address.value = data.address.value;
        }
        if(data?.supportEmail){
            this.supportEmail.value = data.supportEmail.value;
        }
        if(data?.phoneNumber){
            this.phoneNumber.value = data.phoneNumber.value;
        }
    }
}